import React, { useState } from 'react';

const AdminPanel = () => {
  const [showModal, setShowModal] = useState(false);

  const handleAddNewsClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const title = form.title.value;
    const content = form.content.value;

    // TODO: Надіслати новину через API
    console.log('Нова новина:', { title, content });

    setShowModal(false);
  };

  return (
    <div className="admin-panel">
      <h2 className="text-lg font-bold text-yellow-400 mb-4 border-b border-gray-600">Адмін-панель</h2>
      <ul className="list-disc list-inside space-y-2 text-white">
        <li>
          <button className="bg-gray-700 text-white px-3 py-1 rounded hover:bg-gray-600"
                  onClick={handleAddNewsClick}>
            Додати новину
          </button>
        </li>
        {/* інші пункти */}
      </ul>

      {/* Модальне вікно */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-xl font-semibold mb-4">Нова новина</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block mb-1 font-medium">Заголовок</label>
                <input type="text" name="title" required className="w-full border px-3 py-2 rounded" />
              </div>
              <div className="mb-4">
                <label className="block mb-1 font-medium">Текст новини</label>
                <textarea name="content" rows="4" required className="w-full border px-3 py-2 rounded"></textarea>
              </div>
              <div className="flex justify-end space-x-2">
                <button type="button" onClick={handleCloseModal} className="px-4 py-2 bg-gray-500 text-white rounded">
                  Скасувати
                </button>
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">
                  Зберегти
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
